import React from "react";
import "./App.css";
import "./index.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./AuthContext";
import { ThemeProvider } from "./ThemeContext";
import Layout from "./Layout";
import AuthCallback from "./AuthCallback";
import LandingPage from "./pages/LandingPage";
import { LoginPage, RegisterPage } from "./pages/Auth";
import ServicesPage from "./pages/ServicesPage";
import BookingPage from "./pages/BookingPage";
import ProfilePage from "./pages/ProfilePage";
import ReferralsPage from "./pages/ReferralsPage";
import PartnershipsPage from "./pages/PartnershipsPage";
import AdminPage from "./pages/AdminPage";
import PartnerPortal from "./pages/PartnerPortal";
import SejaParceiroPage from "./pages/SejaParceiroPage";
import ComplaintPage from "./pages/ComplaintPage";
import GalleryPage from "./pages/GalleryPage";

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-sm text-[color:var(--ink-500)]">Carregando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !["admin", "admin_admin", "admin_caixa"].includes(user.role)) return <Navigate to="/perfil" replace />;
  return children;
}

function Router() {
  const location = useLocation();
  // Handle Google OAuth callback (fragment #session_id=...) synchronously
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  // Public partner portal (no auth, no layout)
  if (location.pathname.startsWith("/parceiro/")) {
    return (
      <Routes>
        <Route path="/parceiro/:token" element={<PartnerPortal />} />
      </Routes>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/cadastro" element={<RegisterPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/servicos" element={<ServicesPage />} />
        <Route path="/galeria" element={<GalleryPage />} />
        <Route path="/seja-parceiro" element={<SejaParceiroPage />} />
        <Route path="/reclamar" element={<ComplaintPage />} />
        <Route path="/agendar" element={<BookingPage />} />
        <Route path="/parcerias" element={<PartnershipsPage />} />
        <Route path="/indique" element={<ReferralsPage />} />
        <Route path="/perfil" element={<Protected><ProfilePage /></Protected>} />
        <Route path="/admin" element={<Protected adminOnly><AdminPage /></Protected>} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ThemeProvider>
          <BrowserRouter>
            <Router />
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </ThemeProvider>
      </AuthProvider>
    </div>
  );
}
